import romanApi from "@roman/shared/lib/net/romanApi";
import type { PredictionMarketSnapshot, PredictionMarketWithProbability } from "@roman/shared/types/PredictionMarket";
import type { SWRConfiguration } from "swr";
import useSWR from "swr";

export type PredictionMarketHistoryProps = {
  predictionMarketId: string;
  swrOptions?: SWRConfiguration;
  fetcher?: (url: string, predictionMarketId: string) => Promise<PredictionMarketHistoryResponse>;
};

export type PredictionMarketHistoryResponse = {
  predictionMarket: PredictionMarketWithProbability;
  numberOfParticipants: number;
  predictionMarketHistory: PredictionMarketSnapshot[];
};

export const createDefaultPredictionMarketHistoryFetcher = () => {
  return (url: string, predictionMarketId: string) => {
    return romanApi.get<PredictionMarketHistoryResponse>(`${url}/${predictionMarketId}`);
  };
};

export const useGetPredictionMarketHistory = ({
  predictionMarketId,
  swrOptions,
  fetcher,
}: PredictionMarketHistoryProps) => {
  const historyFetcher = fetcher || createDefaultPredictionMarketHistoryFetcher();
  const swrKey = ["/prediction-market/history", predictionMarketId];

  const swrQuery = useSWR<PredictionMarketHistoryResponse>(swrKey, ([url, id]) => historyFetcher(url, id), swrOptions);

  return swrQuery;
};
